import React, { useState, useEffect } from "react";

const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/api$/, "");

/** Displays a client company logo with a graceful fallback.
 *
 * If ``logo_url`` is missing OR the image fails to load (404, network
 * error, corrupt file, evicted from the pod's ephemeral disk after a
 * redeploy, etc.), we render an initial-letter tile instead of the
 * browser's default broken-image placeholder.
 */
export function ClientLogo({ name, logoUrl, size = 40, className = "" }) {
  const [broken, setBroken] = useState(false);
  useEffect(() => { setBroken(false); }, [logoUrl]);

  const initial = ((name || "?").trim()[0] || "?").toUpperCase();
  const dim = { width: `${size}px`, height: `${size}px` };

  if (!logoUrl || broken) {
    return (
      <div
        style={dim}
        data-testid="client-logo-fallback"
        className={`bg-zinc-900 text-white font-display font-extrabold flex items-center justify-center rounded-sm shrink-0 ${className}`}
      >
        {initial}
      </div>
    );
  }

  const src = /^https?:\/\//i.test(logoUrl) ? logoUrl : `${BACKEND}${logoUrl}`;
  return (
    <img
      src={src}
      alt={name || ""}
      style={dim}
      onError={() => setBroken(true)}
      data-testid="client-logo-img"
      className={`object-cover border border-zinc-200 rounded-sm shrink-0 ${className}`}
    />
  );
}
